import script from "./ModalPesqDorape.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalPesqDorape.vue?vue&type=script&setup=true&lang=ts"

import "./ModalPesqDorape.vue?vue&type=style&index=0&id=427639be&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427639be"]])

export default __exports__